import { create } from 'zustand';
import { Company } from '../types/company';

const COMPANY_ID_KEY = 'duzon_company_id';
const COMPANY_NAME_KEY = 'duzon_company_name';
const COMPANY_ROLE_KEY = 'duzon_company_role';
const COMPANY_PLAN_KEY = 'duzon_company_plan';

interface CompanyState {
  companyId: number | null;
  companyName: string | null;
  role: string | null;
  plan: string | null;
  hasCompany: boolean;
  setCompany: (
    company: Pick<Company, 'companyId' | 'companyName' | 'role'> & { plan?: string | null }
  ) => void;
  setPlan: (plan: string | null) => void;
  clearCompany: () => void;
}

function readNumber(key: string): number | null {
  const value = localStorage.getItem(key);
  if (!value) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

const initialCompanyId = readNumber(COMPANY_ID_KEY);
const initialCompanyName = localStorage.getItem(COMPANY_NAME_KEY);
const initialRole = localStorage.getItem(COMPANY_ROLE_KEY);
const initialPlan = localStorage.getItem(COMPANY_PLAN_KEY);

export const useCompanyStore = create<CompanyState>((set) => ({
  companyId: initialCompanyId,
  companyName: initialCompanyName,
  role: initialRole,
  plan: initialPlan,
  hasCompany: Boolean(initialCompanyId),

  setCompany: ({ companyId, companyName, role, plan }) => {
    localStorage.setItem(COMPANY_ID_KEY, String(companyId));
    localStorage.setItem(COMPANY_NAME_KEY, companyName);
    localStorage.setItem(COMPANY_ROLE_KEY, role);
    set((state) => {
      const nextPlan = plan !== undefined ? plan || null : state.plan;
      if (nextPlan) {
        localStorage.setItem(COMPANY_PLAN_KEY, nextPlan);
      }
      return {
        companyId,
        companyName,
        role,
        plan: nextPlan,
        hasCompany: true,
      };
    });
  },

  setPlan: (plan) => {
    if (plan) {
      localStorage.setItem(COMPANY_PLAN_KEY, plan);
    } else {
      localStorage.removeItem(COMPANY_PLAN_KEY);
    }
    set({ plan });
  },

  clearCompany: () => {
    localStorage.removeItem(COMPANY_ID_KEY);
    localStorage.removeItem(COMPANY_NAME_KEY);
    localStorage.removeItem(COMPANY_ROLE_KEY);
    localStorage.removeItem(COMPANY_PLAN_KEY);
    set({
      companyId: null,
      companyName: null,
      role: null,
      plan: null,
      hasCompany: false,
    });
  },
}));
